import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyAgentLinkTarget } from "./-legacy-agent-link";

// ByggeRadar 1.0 agent emails link to /byggeradar/saved/$agentId[/$proposalId]; mails already sent keep working.
export const Route = createFileRoute("/(restricted)/byggeradar/saved/$")({
  beforeLoad: ({ params: { _splat } }) => {
    throw redirect({
      ...legacyAgentLinkTarget(_splat ?? ""),
      search: true,
      replace: true,
    });
  },
});
